var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{key:_vm.uid,staticClass:"swoosh",attrs:{"type":"MarkerLine"}})
}
var staticRenderFns = []

export { render, staticRenderFns }